<template>
  <vca-field :label="$t('organisation.options.header')">
    <vca-checkbox v-model="value.options" id="nvm">{{
      $t("organisation.options.nvm")
    }}</vca-checkbox>
    <vca-checkbox v-model="value.options" id="active">{{
      $t("organisation.options.active")
    }}</vca-checkbox>
    <vca-checkbox v-model="value.options" id="volunteer_cert">{{
      $t("organisation.options.volunteer_cert")
    }}</vca-checkbox>
  </vca-field>
</template>
<script>
export default {
  name: "OrganisationOptions",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
